document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("br, hr").forEach(function (element) {
        element.setAttribute("aria-hidden", "true");
    });
});

// Video Player
(function () {
    function initEcbPlayers(scope) {
      const root = scope || document;
      const players = root.querySelectorAll('[data-ecb-player]:not([data-ecb-initialized="true"])');

      players.forEach((player) => {
        player.setAttribute('data-ecb-initialized', 'true');

        const defaultVideo = player.querySelector('[data-ecb-video-default]');
        const adVideo = player.querySelector('[data-ecb-video-ad]');
        const pauseBtn = player.querySelector('[data-ecb-pause-toggle]');
        const ccBtn = player.querySelector('[data-ecb-cc-toggle]');
        const adBtn = player.querySelector('[data-ecb-ad-toggle]');
        const transcriptBtn = player.querySelector('[data-ecb-transcript-toggle]');
        const transcriptDrawerId = transcriptBtn ? transcriptBtn.getAttribute('aria-controls') : null;
        const transcriptDrawer = transcriptDrawerId ? document.getElementById(transcriptDrawerId) : null;
        const transcriptCloseBtn = transcriptDrawer ? transcriptDrawer.querySelector('[data-ecb-transcript-close]') : null;
        const liveRegion = player.querySelector('.ecb-live');

        // ── seek / progress bar elements ──
        const seekRange = player.querySelector('[data-ecb-seek-range]');
        const rewindBtn = player.querySelector('[data-ecb-rewind-10]');
        const forwardBtn = player.querySelector('[data-ecb-forward-10]');
        const timeCurrentEl = player.querySelector('[data-ecb-time-current]');
        const timeDurationEl = player.querySelector('[data-ecb-time-duration]');

        if (!defaultVideo || !pauseBtn) return;

        const shouldAutoplay = player.getAttribute('data-ecb-autoplay') === 'true';
        const pauseIcon = pauseBtn.querySelector('.ecb-icon-pause');
        const playIcon = pauseBtn.querySelector('.ecb-icon-play');
        const pauseTooltip = pauseBtn.querySelector('.ecb-tooltip');

        function getCurrentVideo() {
          return adVideo && adVideo.style.display !== 'none' ? adVideo : defaultVideo;
        }

        function getCaptionTrack(video) {
          if (!video) return null;
          const htmlTrack = video.querySelector('track[kind="captions"], track[kind="subtitles"]');
          return htmlTrack ? (htmlTrack.track || null) : null;
        }

        function announce(message) {
          if (!liveRegion || !message) return;

          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.textContent = '';

          window.setTimeout(() => {
            liveRegion.textContent = message;

            window.setTimeout(() => {
              liveRegion.textContent = '';
              liveRegion.setAttribute('aria-live', 'off');
            }, 800);
          }, 50);
        }

        function updatePauseButton() {
          const activeVideo = getCurrentVideo();
          const isPaused = activeVideo.paused;

          pauseBtn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
          pauseBtn.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');

          if (pauseTooltip) {
            pauseTooltip.textContent = isPaused ? 'Play' : 'Pause';
          }

          if (pauseIcon) pauseIcon.style.display = isPaused ? 'none' : 'block';
          if (playIcon) playIcon.style.display = isPaused ? 'block' : 'none';
        }

        // ── seek / progress bar helpers ──
        function formatTime(seconds) {
          if (!isFinite(seconds) || isNaN(seconds) || seconds < 0) seconds = 0;
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60);
          return mins + ':' + String(secs).padStart(2, '0');
        }

        function updateSeekGradient(value, max) {
          if (!seekRange) return;
          const pct = max > 0 ? (value / max) * 100 : 0;
          seekRange.style.background =
            'linear-gradient(to right, #ffffff ' + pct + '%, rgba(255,255,255,0.3) ' + pct + '%)';
        }

        function updateProgressUI(video) {
          if (!seekRange || video !== getCurrentVideo()) return;

          const duration = isFinite(video.duration) ? video.duration : 0;
          const currentTime = video.currentTime || 0;

          seekRange.max = duration;
          if (!seekRange.matches(':active')) {
            seekRange.value = Math.min(currentTime, duration);
          }

          if (timeCurrentEl) timeCurrentEl.textContent = formatTime(currentTime);
          if (timeDurationEl) timeDurationEl.textContent = formatTime(duration);

          updateSeekGradient(seekRange.value, duration);
        }

        function handleSeekInput() {
          const video = getCurrentVideo();
          if (!video || !seekRange) return;

          const newTime = parseFloat(seekRange.value);
          video.currentTime = newTime;

          if (timeCurrentEl) timeCurrentEl.textContent = formatTime(newTime);
          updateSeekGradient(newTime, seekRange.max);
        }

        function skipVideo(seconds) {
          const video = getCurrentVideo();
          if (!video) return;

          const duration = isFinite(video.duration) ? video.duration : 0;
          const currentTime = video.currentTime || 0;
          const nextTime = duration > 0
            ? Math.min(Math.max(currentTime + seconds, 0), duration)
            : Math.max(currentTime + seconds, 0);

          try {
            video.currentTime = nextTime;
          } catch (e) {}

          updateProgressUI(video);

          if (seconds < 0) {
            announce('Rewound 10 seconds. Current time ' + formatTime(nextTime));
          } else {
            announce('Forwarded 10 seconds. Current time ' + formatTime(nextTime));
          }
        }

        function setCaptionsState(isOn) {
          [defaultVideo, adVideo].forEach((video) => {
            if (!video) return;
            const track = getCaptionTrack(video);
            if (track) {
              track.mode = 'disabled';
              track.mode = isOn ? 'showing' : 'hidden';
            }
          });

          if (ccBtn) {
            ccBtn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
            ccBtn.setAttribute('aria-label', isOn ? 'CC, Captions on' : 'CC, Captions off');
          }
        }

        function toggleCaptions() {
          const activeTrack = getCaptionTrack(getCurrentVideo());

          if (!activeTrack) {
            announce('No captions available');
            return;
          }

          const nextState = activeTrack.mode !== 'showing';
          setCaptionsState(nextState);
          announce(nextState ? 'Captions on' : 'Captions off');
        }

        function setAdState(isOn) {
          if (!adVideo) {
            announce('Audio description not available');
            return;
          }

          const fromVideo = isOn ? defaultVideo : adVideo;
          const toVideo = isOn ? adVideo : defaultVideo;

          const currentTime = fromVideo.currentTime || 0;
          const wasPaused = fromVideo.paused;
          const captionsWereOn = getCaptionTrack(fromVideo)?.mode === 'showing';

          fromVideo.pause();
          fromVideo.style.display = 'none';
          toVideo.style.display = 'block';

          const syncAndPlay = () => {
            try {
              toVideo.currentTime = currentTime;
            } catch (e) {}

            const track = getCaptionTrack(toVideo);
            if (track) {
              track.mode = captionsWereOn ? 'showing' : 'hidden';
            }

            if (!wasPaused) {
              toVideo.play().catch(() => {});
            }

            if (adBtn) {
              adBtn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
              adBtn.setAttribute('aria-label', isOn ? 'AD, Audio description on' : 'AD, Audio description off');
            }

            updatePauseButton();
            updateProgressUI(toVideo);
          };

          if (toVideo.readyState >= 1) {
            syncAndPlay();
          } else {
            toVideo.load();
            toVideo.addEventListener('loadedmetadata', syncAndPlay, { once: true });
          }
        }

        function toggleAudioDescription() {
          if (!adVideo) {
            announce('Audio description not available');
            return;
          }

          const isAdOn = getCurrentVideo() === adVideo;
          const nextState = !isAdOn;

          setAdState(nextState);
          announce(nextState ? 'Audio description on' : 'Audio description off');
        }

        function togglePlayPause() {
          const activeVideo = getCurrentVideo();

          if (activeVideo.paused) {
            if (!activeVideo.dataset.ecbStarted) {
              activeVideo.currentTime = 0;
              activeVideo.dataset.ecbStarted = 'true';
            }
            activeVideo.muted = false;
            activeVideo.play().catch(() => {});
          } else {
            activeVideo.pause();
          }

          updatePauseButton();
        }

        function handleVideoClick(e) {
          if (e.target.closest('.ecb-controls')) return;
          if (e.target.closest('.ecb-seekbar')) return;
          togglePlayPause();
        }

        function setTranscriptState(isOpen) {
          if (!transcriptDrawer || !transcriptBtn) return;

          transcriptDrawer.style.display = isOpen ? 'block' : 'none';
          transcriptBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        function toggleTranscript() {
          if (!transcriptBtn) return;
          const isOpen = transcriptBtn.getAttribute('aria-expanded') === 'true';
          setTranscriptState(!isOpen);
        }

        function closeTranscript() {
          setTranscriptState(false);
          if (transcriptBtn) transcriptBtn.focus();
        }

        pauseBtn.addEventListener('click', togglePlayPause);
        if (ccBtn) ccBtn.addEventListener('click', toggleCaptions);
        if (adBtn) adBtn.addEventListener('click', toggleAudioDescription);
        if (transcriptBtn) transcriptBtn.addEventListener('click', toggleTranscript);
        if (transcriptCloseBtn) transcriptCloseBtn.addEventListener('click', closeTranscript);

        // ── seek bar events ──
        if (seekRange) {
          seekRange.addEventListener('click', (e) => e.stopPropagation());
          seekRange.addEventListener('input', handleSeekInput);
        }

        if (rewindBtn) {
          rewindBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            skipVideo(-10);
          });
        }

        if (forwardBtn) {
          forwardBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            skipVideo(10);
          });
        }

        defaultVideo.addEventListener('click', handleVideoClick);
        defaultVideo.style.cursor = 'pointer';

        defaultVideo.addEventListener('play', updatePauseButton);
        defaultVideo.addEventListener('pause', updatePauseButton);
        defaultVideo.addEventListener('ended', updatePauseButton);
        defaultVideo.addEventListener('timeupdate', () => updateProgressUI(defaultVideo));
        defaultVideo.addEventListener('loadedmetadata', () => updateProgressUI(defaultVideo));
        defaultVideo.addEventListener('durationchange', () => updateProgressUI(defaultVideo));

        if (adVideo) {
          adVideo.addEventListener('click', handleVideoClick);
          adVideo.style.cursor = 'pointer';
          adVideo.addEventListener('play', updatePauseButton);
          adVideo.addEventListener('pause', updatePauseButton);
          adVideo.addEventListener('ended', updatePauseButton);
          adVideo.addEventListener('timeupdate', () => updateProgressUI(adVideo));
          adVideo.addEventListener('loadedmetadata', () => updateProgressUI(adVideo));
          adVideo.addEventListener('durationchange', () => updateProgressUI(adVideo));
          adVideo.style.display = 'none';
          // ✅ FIX: Reset AD video on page load so poster shows correctly
          adVideo.load();
        }

        defaultVideo.style.display = 'block';

        // ✅ FIX: Reset default video on every page load to force poster display
        defaultVideo.load();
        defaultVideo.currentTime = 0;

        setCaptionsState(false);
        setTranscriptState(false);
        updateProgressUI(defaultVideo);

        if (shouldAutoplay) {
          defaultVideo.muted = true;
          defaultVideo.play().catch(() => {});
        }

        updatePauseButton();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initEcbPlayers(document);
      });
    } else {
      initEcbPlayers(document);
    }
  })();


(function () {
  // Desktop Qikify parent items that only toggle a submenu
  var SEL = 'li.tmenu_item--root.tmenu_item_has_child > a.tmenu_item_link.site-nav__link';

  function fix(root) {
    (root.querySelectorAll ? root : document).querySelectorAll(SEL).forEach(function (a) {
      if (a.getAttribute('role') !== 'button') a.setAttribute('role', 'button'); // it's a toggle, not a link
      if (a.hasAttribute('aria-haspopup')) a.removeAttribute('aria-haspopup');   // disclosure, not a menu
      if (a.hasAttribute('title')) a.removeAttribute('title');                   // duplicates the visible text
    });
  }

  fix(document);
  // Qikify (Vue) re-renders the menu, so re-apply whenever it changes
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      fix(m.type === 'attributes' ? (m.target.parentNode || document) : m.target);
    });
  }).observe(document.body, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['aria-haspopup', 'role']
  });
})();


/* ADA #8 start – internal links same tab, external links new tab + warning span
   (replaces the old "Social and External link warning" aria-label block) */
(function () {
  var WARNING = 'Redirecting to a third-party website, opens in a new tab.';
  var host = window.location.hostname.replace(/^www\./, '');
  // Hosts that belong to this store – links to them are internal
  // (subdomains such as help. / swatches. stay external)
  var internalHosts = [host, 'premiertablelinensrush.com', 'premier-table-linens-ptl.myshopify.com', 'cdn.shopify.com'];

  function isExternal(link) {
    if (!/^https?:$/.test(link.protocol)) return false; // mailto:, tel:, javascript:
    return internalHosts.indexOf(link.hostname.replace(/^www\./, '')) === -1;
  }

  function fixLink(link) {
    var label = link.getAttribute('aria-label');
    if (label && label.indexOf(WARNING) !== -1) {
      // Remove the old warning text (saved by GemPages, sometimes twice)
      label = label.split(WARNING).join('').replace(/\s+/g, ' ').trim();
      if (label) link.setAttribute('aria-label', label);
      else link.removeAttribute('aria-label');
    }

    if (isExternal(link)) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer nofollow');
      if (!link.querySelector('.ada-ext-warning')) {
        var span = document.createElement('span');
        span.className = 'ada-ext-warning';
        span.textContent = ' ' + WARNING;
        link.appendChild(span);
      }
      // aria-label overrides the link content, so the span would not be read
      if (label) link.setAttribute('aria-label', label + ' ' + WARNING);
    } else if (link.getAttribute('target') === '_blank') {
      link.removeAttribute('target');
    }
  }

  function scan(root) {
    if (root.matches && root.matches('a[href]')) fixLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(fixLink);
  }

  function run() {
    scan(document.body);
    // Links added later (Qikify menu, apps)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(scan); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
/* ADA #8 end */


// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const title = ($link.attr('title') || '').trim();
    const visibleText = $link.text().trim();
    const existingLabel = ($link.attr('aria-label') || '').trim();

    // Do not overwrite an existing aria-label
    if (existingLabel) {
      return;
    }

    // Use title first, otherwise visible text
    let labelText = title || visibleText;

    // Remove existing "Phone Number:" prefix if present
    labelText = labelText.replace(/^Phone Number:\s*/i, '');

    if (labelText) {
      $link.attr('aria-label', `Phone Number: ${labelText}`);
    }
  });
});


// Email Label to all Email Address
$(document).ready(function() {
  $('a[href^="mailto:"]').each(function() {
    const $link = $(this);
    const title = ($link.attr('title') || '').trim();
    const existingLabel = ($link.attr('aria-label') || '').trim();

    // Do not overwrite an existing aria-label
    if (existingLabel) {
      return;
    }

    // Extract email from mailto
    let email = $link.attr('href').replace(/^mailto:/i, '').trim();

    email = decodeURIComponent(email)
      .split('?')[0]
      .split('&')[0];

    // Use title first, otherwise email
    let labelText = title || email;

    // Remove existing "Email Address:" prefix if present
    labelText = labelText.replace(/^Email Address:\s*/i, '');

    if (labelText) {
      $link.attr('aria-label', `Email Address: ${labelText}`);
    }
  });
});

// empty Headings
$(document).ready(function() {
    $('h1, h2, h3, h4, h5, h6').filter(function() {
      return $(this).text().replace(/\s+/g, '') === '' &&  $(this).children().length === 0;
    }).remove();
});

/* Search button - SearchDrawer - focus return on close */
$(document).ready(function () {
  var btn = document.getElementById('regular-search');
  var drawer = document.getElementById('SearchDrawer');
  if (!btn || !drawer) return;

  // theme.js onDrawerClose() focuses [data-predictive-search-open-drawer],
  // and Drawer.open/close toggle aria-expanded on the clicked button.
  btn.setAttribute('data-predictive-search-open-drawer', '');
  btn.setAttribute('aria-controls', 'SearchDrawer');
  btn.setAttribute('aria-expanded', 'false');

  // Safety net: delayed blur handlers (Boost autocomplete / predictive search)
  // can run after the theme's focus call and leave focus on <body>.
  // After the drawer closes, re-check briefly and return focus to the button
  // only if focus is lost (body/none or still inside the hidden drawer).
  function focusLost() {
    var el = document.activeElement;
    return !el || el === document.body || el === document.documentElement || drawer.contains(el);
  }

  function restoreFocus() {
    var tries = 0;
    (function check() {
      if (focusLost() && btn.offsetParent !== null) btn.focus();
      if (++tries < 6) setTimeout(check, 50);
    })();
  }

  // Drawer.close() always removes js-drawer-open-top from <html>
  // (close button, Esc, outside click), so watch that instead of adding
  // click/key listeners that could interfere with the button.
  var root = document.documentElement;
  var wasOpen = root.classList.contains('js-drawer-open-top');
  new MutationObserver(function () {
    var isOpen = root.classList.contains('js-drawer-open-top');
    if (wasOpen && !isOpen) restoreFocus();
    wasOpen = isOpen;
  }).observe(root, { attributes: true, attributeFilter: ['class'] });
});


/* ADA #4 start – Gravity "Rondell" product gallery (injected by app, layout/theme.liquid:308-310) */
(function () {
  function enhance(container) {
    var items = Array.prototype.slice.call(container.querySelectorAll('.rondell-item'));
    if (!items.length || container.hasAttribute('data-ada-gallery')) return !!items.length;
    container.setAttribute('data-ada-gallery', 'true');

    var total = items.length;
    var prev = null;
    var next = null;

    // 1. Named carousel region
    container.setAttribute('role', 'region');
    container.setAttribute('aria-roledescription', 'carousel');
    container.setAttribute('aria-label', 'Product images');

    // Hidden status message announced when the slide changes
    var status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    container.parentNode.appendChild(status);

    // Thumbnails are grouped and labelled. The wrapper has no positioning, so the
    // absolutely positioned thumbnails still lay out against the container.
    var thumbGroup = document.createElement('div');
    thumbGroup.className = 'ada-rondell-thumbs';
    thumbGroup.setAttribute('role', 'group');
    thumbGroup.setAttribute('aria-label', 'Product image thumbnails');

    // 2. Arrows: the <a> is the control (role="button" + name, one tab stop).
    // The app's empty inner <button> is hidden from the tab order and screen readers.
    container.querySelectorAll('.rondell-control').forEach(function (control) {
      var btn = control.querySelector('button');
      if (!btn) return;
      var label = '';
      if (btn.classList.contains('lg-prev')) {
        label = 'Previous slide';
        prev = control;
      } else if (btn.classList.contains('lg-next')) {
        label = 'Next slide';
        next = control;
      }
      if (!label) return;

      control.removeAttribute('href');
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', label);
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-hidden', 'true');

      control.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          // Click the inner button so the event bubbles through the <a> and
          // reaches the app's handler whichever element it is bound to.
          btn.click();
        }
      });
    });

    // Thumbnails act as buttons, so Space must activate them too (Enter already works)
    items.forEach(function (item) {
      item.addEventListener('keydown', function (e) {
        if (e.key === ' ' && item.getAttribute('role') === 'button') {
          e.preventDefault();
          item.click();
        }
      });
    });

    var lastIndex = -1;

    function refresh() {
      // Slides don't open a new window (thumbnails switch the slide, the main image
      // opens the zoom dialog in the same window), so remove the theme's
      // new-window / external warning (theme.js accessibleLinks).
      items.forEach(function (item) { item.removeAttribute('aria-describedby'); });

      var current = container.querySelector('.rondell-item.rondell-item-focused');
      var currentIndex = items.indexOf(current);
      if (currentIndex === -1 || currentIndex === lastIndex) return;

      // 4–5. Names and current state
      items.forEach(function (item, i) {
        var img = item.querySelector('.rondell-item-image');
        var alt = img && img.alt ? img.alt.trim() : '';
        if (i === currentIndex) {
          item.removeAttribute('role');
          item.removeAttribute('aria-current');
          // Main image is named by its own alt text; fallback only if the alt is empty
          if (alt) item.removeAttribute('aria-label');
          else item.setAttribute('aria-label', 'Product image');
        } else {
          item.setAttribute('role', 'button');
          item.removeAttribute('aria-current');
          item.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + total);
        }
      });

      // 3. Reading order: main image, Previous, Next, then the thumbnail group.
      // Layout is unchanged because the app positions every item absolutely.
      var active = document.activeElement;
      [current, prev, next, thumbGroup].forEach(function (el) { if (el) container.appendChild(el); });
      items.forEach(function (item) { if (item !== current) thumbGroup.appendChild(item); });
      if (active && active !== document.activeElement && container.contains(active)) active.focus();

      if (lastIndex !== -1) status.textContent = 'Showing image ' + (currentIndex + 1) + ' of ' + total;
      lastIndex = currentIndex;
    }

    refresh();
    new MutationObserver(refresh).observe(container, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-describedby'] });
    return true;
  }

  // The app builds the slider after page load, so wait for it to appear
  document.addEventListener('DOMContentLoaded', function () {
    var group = document.querySelector('[data-product-single-media-group]');
    if (!group) return;

    function check() {
      var container = group.querySelector('#rondellCarousel .rondell-container');
      return container ? enhance(container) : false;
    }

    if (check()) return;
    var observer = new MutationObserver(function () {
      if (check()) observer.disconnect();
    });
    observer.observe(group, { childList: true, subtree: true });
  });
})();
/* ADA #4 end */

/* ADA #5 start – APD product description tabs (snippets/apd.liquid) */
(function () {
  function initApdTabs(root, r) {
    var list = root.querySelector('.apd-tabs-list');
    var tabs = root.querySelectorAll('.apd-tabs-list-item');
    var panels = root.querySelectorAll('.apd-tab');
    if (!list || !tabs.length) return;

    list.setAttribute('role', 'tablist');
    list.setAttribute('aria-label', 'Product information');

    function sync() {
      tabs.forEach(function (tab) {
        var on = tab.classList.contains('apd-active');
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    tabs.forEach(function (tab, i) {
      var tabId = 'apd-tab-' + r + '-' + i, panelId = 'apd-panel-' + r + '-' + i;
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      if (panels[i]) {
        tab.setAttribute('aria-controls', panelId);
        panels[i].id = panelId;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tabId);
        panels[i].setAttribute('tabindex', '0');
      }
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % n;
        else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tab.click(); return; }
        if (next === null) return;
        e.preventDefault();
        tabs[next].click();   // runs the app's own jQuery handler
        tabs[next].focus();
      });
      // keep ARIA in sync with the app's class changes (click and swipe)
      new MutationObserver(sync).observe(tab, { attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  function run() {
    document.querySelectorAll('.tabs-view').forEach(function (root, r) { initApdTabs(root, r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
/* ADA #5 end */

/* ADA #6 start – APD product description accordion (snippets/apd.liquid, mobile view + accordion mode) */
(function () {
  function run() {
    document.querySelectorAll('.apd-acc-section-header').forEach(function (header, i) {
      var heading = header.querySelector('h1, h2');
      var content = header.nextElementSibling;
      if (!heading || heading.querySelector('.apd-acc-toggle')) return;

      // button inside the heading keeps heading navigation and adds a button role
      var btn = document.createElement('span');
      btn.className = 'apd-acc-toggle';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      while (heading.firstChild) btn.appendChild(heading.firstChild);
      heading.appendChild(btn);

      if (content && content.classList.contains('apd-content')) {
        content.id = content.id || 'apd-acc-panel-' + i;
        btn.setAttribute('aria-controls', content.id);
      }
      header.querySelectorAll('svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      });

      function sync() {
        btn.setAttribute('aria-expanded', header.classList.contains('apd-active') ? 'true' : 'false');
      }
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        header.click();   // runs the app's own jQuery handler
      });
      // keep aria-expanded in sync with the app's class changes (incl. "close others")
      new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
/* ADA #6 end */

/* ADA #7 start – remove theme.js accessibleLinks ids (assets/theme.js:379, 7664) and the copies GemPages saved into templates */
$(function () {
  var themeIds = ['a11y-external-message', 'a11y-new-window-message', 'a11y-new-window-external-message'];
  $('[aria-describedby]').each(function () {
    var ids = this.getAttribute('aria-describedby').split(/\s+/).filter(function (id) {
      return id && themeIds.indexOf(id) === -1;
    });
    if (ids.length) this.setAttribute('aria-describedby', ids.join(' '));
    else this.removeAttribute('aria-describedby');
  });
  $('#a11y-external-message').closest('ul[hidden]').remove();
});
/* ADA #7 end */
